import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addPerson } from '../../store/thunks/leadsActions';

export default function AddPersonForm({ leadId, onSuccess }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [title, setTitle] = useState('');
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();

const handleAdd = async () => {
  if (!firstName) return;

  try {
    await dispatch(addPerson({
      leadId,
      person: {
        first_name: firstName,
        last_name: lastName,
        title,
        email
      }
    })).unwrap(); // 🔥 make sure to unwrap for proper error/return

    if (onSuccess) onSuccess(); // ✅ tell parent to refresh

    setFirstName('');
    setLastName('');
    setTitle('');
    setEmail('');
  } catch (err) {
    console.error('Failed to add person:', err);
  }
};


  return (
    <div className="mt-2 space-y-2">
      <input
        type="text"
        placeholder="First Name"
        className="w-full p-2 border rounded-[12px] text-[#1F2937]"
        value={firstName}
        onChange={e => setFirstName(e.target.value)}
      />
      <input
        type="text"
        placeholder="Last Name"
        className="w-full p-2 border rounded-[12px] text-[#1F2937]"
        value={lastName}
        onChange={e => setLastName(e.target.value)}
      />
      <input
        type="text"
        placeholder="Title"
        className="w-full p-2 border rounded-[12px] text-[#1F2937]"
        value={title}
        onChange={e => setTitle(e.target.value)}
      />
      <input
        type="email"
        placeholder="Email (optional)"
        className="w-full p-2 border rounded-[12px] text-[#1F2937]"
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
      <button
        className="px-3 py-2 rounded-[12px]"
        style={{ backgroundColor: '#2563EB', color: '#FFFFFF' }}
        onClick={handleAdd}
      >
        Add Person
      </button>
    </div>
  );
}